import {
  Input,
  RelativeDiv,
  ValidationScript
} from "../../assets/GlobalStyles";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {useAtom} from "jotai";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import {selAdminInfo, updateAdmin} from "../../services/platform/ManageAdminAxios";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {PwChange} from "./UserDetail";
import {modalController} from "../../store";
import {adminInfoAtom} from "./entity/common";
import PlatformSectionHeader from "./PlatformSectionHeader";


function PlatformAdminDetail() {
  const [, setModal] = useAtom(modalController)
  const [adminInfoState, setAdminInfoState] = useAtom(adminInfoAtom)
  const {register, handleSubmit, reset, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: adminInfoState
  })
  const {state} = useLocation();
  const params=useParams();
  const isMyPage=params.id==="myPageAdmin";
  const isNew=state?.id==="NEW";
  const onError = (error) => console.log(error)
  const navigate = useNavigate()

  useEffect(() => {
    if (state?.data) {
      const selectedAdmin = {
        ...state.data,
        activeYn: state.data.status === 'NORMAL' ? 'Y' : 'N'
      };
      setAdminInfoState(selectedAdmin);
      reset(selectedAdmin);
      return () => setModal({isShow: false});
    }

    selAdminInfo().then(response => {
      if (response) {
        const adminInfo = {
          ...response,
          activeYn: response.status === 'NORMAL' ? 'Y' : 'N'
        };

        setAdminInfoState(adminInfo);
        reset(adminInfo);
      }
    });

    return () => {
      setModal({isShow: false});
    };
  }, [reset, setAdminInfoState, setModal, state?.id, state?.data]);

  /**
   * 아이디 입력
   * @param event
   */
  const handleAdminId = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      email: event.target.value
    })
  }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      name: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      phoneNumber: event.target.value
    })
  }
  /**
   * 사용여부
   * @param activeYn
   */
  const handleActiveYn = (activeYn) => {
    setAdminInfoState({
      ...adminInfoState,
      activeYn: activeYn
    })
  }

  const onSubmit = () => {
    updateAdmin(adminInfoState).then((response) => {
      if (response) {
        toast.success("수정 되었습니다.",{onClose: () => navigate('/board/dashboard'), autoClose:100, delay:0})
      } else {
        toast.warning("어드민 계정이 수정이 실패 하였습니다.")
      }
    })
  }
  const onModalPw = () => {
    setModal({
      isShow: false,
      modalComponent: null
    })
  }

  const handleSavePassword = (data) =>{
    updateAdmin(data).then(response => {
      if (response) {
        toast.success("수정 되었습니다.", {onClose:() => {
          setModal({
            isShow: false,
            modalComponent: null
          })
        }})
      } else {
        toast.warning("수정이 실패 하였습니다. 관리자한테 문의하세요")
      }
    })
  }
  return (
    <AdminDetailPage>
    <ProfileHero>
      <HeroCopy><span>MY PROFILE</span><strong>{isMyPage?"내 계정 정보를 관리합니다.":"관리자 정보를 확인하고 수정합니다."}</strong><p>계정 아이디와 담당자 연락처, 사용 상태를 한 화면에서 확인할 수 있습니다.</p></HeroCopy>
      <ProfileSummary>
        <Avatar>{(adminInfoState.name||adminInfoState.email||"A").charAt(0).toUpperCase()}</Avatar>
        <div><strong>{adminInfoState.name||"관리자"}</strong><span>{adminInfoState.email||"-"}</span></div>
        <Status $active={adminInfoState.activeYn==="Y"}>{adminInfoState.activeYn==="Y"?"활성화":"비활성화"}</Status>
      </ProfileSummary>
    </ProfileHero>
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <DetailCard>
        <PlatformSectionHeader title="기본 정보" description="로그인 계정과 비밀번호 정보를 확인하고 관리합니다."/>
        <CardBody>
          <FieldRow>
            <FieldLabel>아이디</FieldLabel>
            <IdControls>
              <RelativeDiv>
                <Input type="text" placeholder="이메일 형태 아이디를 입력해주세요" value={adminInfoState.email||""} readOnly={!isNew}
                  {...(isNew?register("email",{required:"관리자 아이디를 입력해주세요"}):{})} onChange={isNew?handleAdminId:undefined}/>
                {errors.email&&<ValidationScript>{errors.email.message}</ValidationScript>}
              </RelativeDiv>
              {!isNew&&<PwChange title="비밀번호 변경" modalInfo="ADMIN" onSave={handleSavePassword} onSubmit={onModalPw}/>}
            </IdControls>
          </FieldRow>
        </CardBody>
      </DetailCard>
      <DetailCard>
        <PlatformSectionHeader title="담당자 정보" description="서비스 운영에 사용되는 관리자 담당자 정보를 관리합니다."/>
        <CardBody>
          <FieldRow><FieldLabel>담당자명</FieldLabel><RelativeDiv>
            <Input type="text" placeholder="담당자 명을 입력해주세요" value={adminInfoState.name||""} readOnly={!isNew}
              {...(isNew?register("name",{required:"담당자 명을 입력해주세요"}):{})} onChange={isNew?handleManagerName:undefined}/>
            {errors.name&&<ValidationScript>{errors.name.message}</ValidationScript>}
          </RelativeDiv></FieldRow>
          <FieldRow><FieldLabel>담당자 연락처</FieldLabel><RelativeDiv>
            <Input type="text" placeholder="연락처를 입력해주세요." {...register("phoneNumber",{required:"담당자 연락처를 입력해주세요.",pattern:{value:/^[0-9-]+$/g,message:"연락처 형식을 확인해주세요"}})}
              value={adminInfoState.phoneNumber||""} onChange={handleManagerPhone}/>
            {errors.phoneNumber&&<ValidationScript>{errors.phoneNumber.message}</ValidationScript>}
          </RelativeDiv></FieldRow>
          {!isNew&&!isMyPage&&<FieldRow><FieldLabel>사용 여부</FieldLabel><StatusOptions>
            <StatusOption $active={adminInfoState.activeYn==="Y"}><input type="radio" name="useManager" checked={adminInfoState.activeYn==="Y"} onChange={()=>handleActiveYn("Y")}/><span>활성화</span></StatusOption>
            <StatusOption $active={adminInfoState.activeYn!=="Y"} $danger><input type="radio" name="useManager" checked={adminInfoState.activeYn!=="Y"} onChange={()=>handleActiveYn("N")}/><span>비활성화</span></StatusOption>
          </StatusOptions></FieldRow>}
        </CardBody>
      </DetailCard>
      <ActionBar><ActionGuide><strong>{isMyPage?"마이페이지 설정":"관리자 정보 설정"}</strong><span>변경한 정보를 확인한 뒤 수정 버튼을 눌러 저장해 주세요.</span></ActionGuide>
        <ActionButtons>{!isMyPage&&<Cancel type="button" onClick={()=>navigate("/board/platformAdmin")}>취소</Cancel>}<Save type="submit">수정</Save></ActionButtons>
      </ActionBar>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </form>
    </AdminDetailPage>
  )
}

export default PlatformAdminDetail

const AdminDetailPage=styled.div`display:flex;flex-direction:column;gap:16px;form{display:flex;flex-direction:column;gap:16px;}`;
const ProfileHero=styled.section`display:flex;align-items:center;justify-content:space-between;gap:24px;padding:22px 24px;border:1px solid #dce7f4;border-radius:12px;background:linear-gradient(135deg,var(--color-surface) 0%,#f1f7ff 100%);@media(max-width:720px){align-items:flex-start;flex-direction:column;}`;
const HeroCopy=styled.div`>span{color:var(--color-primary-strong);font-size: var(--font-size-11);font-weight:800;letter-spacing:1.2px;}strong{display:block;margin-top:7px;color:#20242b;font-size: var(--font-size-21);font-weight:800;}p{margin:7px 0 0;color:#7f8994;font-size: var(--font-size-12);}`;
const ProfileSummary=styled.div`display:flex;min-width:310px;align-items:center;gap:12px;padding:12px 14px;border:1px solid #dbe5f0;border-radius:10px;background:rgba(255,255,255,.82);>div{display:flex;min-width:0;flex:1;flex-direction:column;}div strong{color:#303741;font-size: var(--font-size-14);}div span{margin-top:3px;color:#8a939d;font-size: var(--font-size-11);}@media(max-width:500px){width:100%;min-width:0;}`;
const Avatar=styled.span`display:flex;width:40px;height:40px;flex:0 0 40px;align-items:center;justify-content:center;border-radius:10px;background:var(--color-primary-muted);color:var(--color-primary-strong);font-size: var(--font-size-17);font-weight:850;`;
const Status=styled.span`padding:5px 9px;border:1px solid ${({$active})=>$active?"#b7e4cd":"#f3b7b7"};border-radius:999px;background:${({$active})=>$active?"#edf9f3":"#fff1f1"};color:${({$active})=>$active?"#168253":"#d04444"};font-size: var(--font-size-11);font-weight:700;`;
const DetailCard=styled.section`overflow:hidden;border:1px solid #e1e6eb;border-radius:11px;background:var(--color-surface);box-shadow:0 5px 18px rgba(31,41,55,.04);`;
const CardBody=styled.div`padding:0 22px 8px;`;
const FieldRow=styled.div`display:grid;grid-template-columns:150px minmax(0,1fr);align-items:center;gap:20px;min-height:76px;padding:13px 8px;border-bottom:1px solid var(--color-divider);&:last-child{border-bottom:0;} ${Input}{width:100%;height:42px;border:1px solid #dce2e8;border-radius:7px;background:var(--color-surface);font-size: var(--font-size-13);} ${Input}[readonly]{background:#f5f6f7;color:#707983;}@media(max-width:650px){grid-template-columns:1fr;gap:8px;}`;
const FieldLabel=styled.strong`color:#444;font-size: var(--font-size-13);font-weight:700;`;
const IdControls=styled.div`display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:10px;button{height:42px!important;border-color:var(--color-primary-border)!important;border-radius:7px!important;background:var(--color-primary-soft)!important;color:var(--color-primary-strong)!important;font-size: var(--font-size-12)!important;font-weight:700!important;}@media(max-width:520px){grid-template-columns:1fr;}`;
const StatusOptions=styled.div`display:flex;gap:8px;`;
const StatusOption=styled.label`display:flex;height:34px;align-items:center;padding:0 13px;border:1px solid ${({$active,$danger})=>$active?($danger?"#f0b9b9":"#aedfc6"):"#dfe4e9"};border-radius:7px;background:${({$active,$danger})=>$active?($danger?"#fff2f2":"#edf9f3"):"var(--color-surface)"};color:${({$active,$danger})=>$active?($danger?"#c94545":"#168253"):"#737c85"};font-size: var(--font-size-12);font-weight:700;cursor:pointer;input{position:absolute;opacity:0;}`;
const ActionBar=styled.div`display:flex;align-items:center;justify-content:space-between;gap:20px;padding:14px 18px;border:1px solid #dce5ef;border-left:3px solid var(--color-primary-strong);border-radius:9px;background:var(--color-surface);`;
const ActionGuide=styled.div`strong,span{display:block;}strong{color:#303741;font-size: var(--font-size-13);}span{margin-top:4px;color:#8b949e;font-size: var(--font-size-11);}`;
const ActionButtons=styled.div`display:flex;gap:8px;button{width:108px;height:39px;border-radius:7px;font-size: var(--font-size-12);font-weight:700;}`;
const Cancel=styled.button`border:1px solid #cfd5db;background:var(--color-surface);color:#555;`;
const Save=styled.button`border:1px solid var(--color-primary-strong);background:var(--color-primary-strong);color:var(--color-surface);`;

